import {
  type QuizQuestionRank,
  type QuizQuestionRankOption,
} from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { generateRandomSlug } from '@efdigital/ll-admin-v2/lib/random-slug.ts';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { Type } from '@warp-drive/core/types/symbols';

import { type QuizQuestionEditorComponentSignature } from '../../types/question-manager.ts';
import { EditOptions } from './shared/edit-options.gts';
import RequiredCheckbox from './shared/required-checkbox.gts';

export class RankQuestionEditorComponent extends Component<QuizQuestionEditorComponentSignature> {
  get questionData(): QuizQuestionRank {
    return this.args.question.rank!;
  }

  updateOptions = (options: QuizQuestionRankOption[]) => {
    this.questionData.options = options;
  };

  addOption = () => {
    this.questionData.options.push({
      [Type]: DataTypeQuiz.QuizQuestionRankOption,
      oid: generateRandomSlug(),
      value: '',
      category: '',
    });
  };

  updateOption = (option: QuizQuestionRankOption, event: Event) => {
    option.value = (event.target as HTMLInputElement).value;
  };

  removeOptionAt = (index: number) => {
    this.questionData.options.splice(index, 1);
  };

  setMin = (event: Event) => {
    this.questionData.min =
      parseInt((event.target as HTMLInputElement).value) || 0;
  };

  setMax = (event: Event) => {
    this.questionData.max =
      parseInt((event.target as HTMLInputElement).value) || 0;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <RequiredCheckbox @question={{@question}} />

        <div class="form-group mb-3">
          <div class="form-label">Rank</div>
          <div class="form-text">The user can rank the options in a specific
            order. You can set a minimum and maximum number of options that the
            user can choose.</div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label class="form-label" for="{{uniqueId}}-min">Minimum</label>
              <input
                type="number"
                class="form-control"
                id="{{uniqueId}}-min"
                value={{this.questionData.min}}
                {{on "change" this.setMin}}
              />
            </div>

          </div>
          <div class="col-md-6">

            <div class="form-group mb-4">
              <label class="form-label" for="{{uniqueId}}-max">Maximum</label>
              <input
                type="number"
                class="form-control"
                id="{{uniqueId}}-max"
                value={{this.questionData.max}}
                {{on "change" this.setMax}}
              />
            </div>
          </div>
        </div>

        <EditOptions
          @uniqueId={{uniqueId}}
          @options={{this.questionData.options}}
          @updateOptions={{this.updateOptions}}
          @updateOption={{this.updateOption}}
          @removeOptionAt={{this.removeOptionAt}}
          @addOption={{this.addOption}}
        />
      </div>
    {{/let}}
  </template>
}
